module.exports = __webpack_public_path__ + "static/media/mainBear.2b50d06a.jpg";